import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { RedirectCommand, Router, UrlTree } from '@angular/router';
import { PagesEnum } from '../enums';
import { UserAccountService } from '../services/user-account.service';

@Injectable()
export class AuthGuard {
  readonly #userAccountService = inject(UserAccountService);
  readonly #router = inject(Router);
  readonly #platformId = inject(PLATFORM_ID);

  async canActivate(): Promise<boolean | UrlTree | RedirectCommand> {
    // During SSR, allow navigation - auth check will happen on client
    if (!isPlatformBrowser(this.#platformId)) {
      return true;
    }

    // Wait for state restoration to complete
    await this.#userAccountService.waitForStateRestoration();

    const userDetails = this.#userAccountService.userDetails();

    if (!userDetails) {
      return new RedirectCommand(this.#router.parseUrl(`/${PagesEnum.LOGIN}`));
    }

    return true;
  }
}
